export const CLASSES_TYPES = {
    GET_CLASSES: 'GET_CLASSES',
}